// extracted by mini-css-extract-plugin
module.exports = {"termUpdatedBox":"IllegalValueBox_termUpdatedBox__vz6G_"};